export default {
  hsk_left_time: 'Tiempo restante',
  hsk_submit_paper: 'Enviar',
  hsk_rotate_device_title: 'Gire su dispositivo a horizontal',
  hsk_rotate_device_desc: 'Para la mejor experiencia de prueba',
  hsk_not_finished: 'Sin terminar',
  hsk_not_start: 'Sin empezar',
  hsk_finished: 'Completado',
  hsk_if_test: 'No ha terminado su último trabajo. ¿Continuar?',
  hsk_start_again: 'Reiniciar',
  hsk_go_on: 'Continuar',
  hsk_if_save: '¿Abandonar? Sus respuestas se guardarán para que pueda continuar la próxima vez.',
  hsk_login_filed: '您的登录信息已失效，我们将不会保留您的答题记录',
  hsk_report: 'Resultados',
  hsk_point: 'Puntos',
  hsk_qualified_point: 'Nota de aprobación: {points}',
  hsk_part1: 'Parte {part}',
  hsk_accuracy1: 'Correcto',
  hsk_test_again: 'Prueba nuevamente',
  hsk_example: 'Ejemplo',
  hsk_example_eg: '例',
  hsk_answer_analysis: 'Respuesta correcta',
  hsk_your_answer: 'Su respuesta:',
  hsk_audio_text: 'Audio:',
  hsk_correct_answer: 'Ejemplo:',
  hsk_listen_name: 'Comprensión auditiva',
  hskk_listen_name: 'Depuración del equipo',
  hsk_read_name: 'Comprensión de lectura',
  hsk_write_name: 'Expresión e interacción escrita',
  hsk_reference_answer: 'Ejemplo:',
  hsk_submit_msg: 'Envíe sus respuestas',
  hsk_homework_no_answer: 'Sin responder',
  hsk_practice_sava: '¿Abandonar? Sus respuestas no se guardarán.',
  hsk_practice_go: 'Intentelo',
  hsk_practice_part: 'Sección',
  hsk_practice_operate: 'Acciones',
  hsk_practice_check: 'Ver',
  hsk_practice_num1: 'Correcto',
  hsk_practice_num2: 'de {totalNum} preguntas en total',
  hsk_preview_listen_msg:
    'Reproduzca el audio de introducción a este examen. Mientras se reproduce la introducción, puede obtener una vista previa de las preguntas en la sección de comprensión auditiva de la prueba haciendo clic en los números de las preguntas.',
  hsk_preview_listen_prompt:
    'Se está reproduciendo la introducción del examen. Durante este tiempo, puede hacer clic en los números de la sección de comprensión auditiva para previsualizar las preguntas. No actualice ni cierre la página durante el examen, ya que se perderán los datos.',
  hsk_enter_next_segment_msg: '¿Continuar a la siguiente sección?',
  hsk_enter_next_segment_preview: '¿Finalizar vista previa? Tras finalizar, comenzará la sección de comprensión auditiva.',
  hsk_enter_next_segment_listen_tip: 'Tiene {count} preguntas de comprensión auditiva sin responder,',
  hsk_enter_next_segment_listen: '¿Enviar sección de comprensión auditiva? Tras enviar, esta sección finalizará.',
  hsk_enter_next_segment_listen_review_start:
    'Ahora está en la fase de revisión de comprensión auditiva. Dispone de {count} minutos para revisar sus respuestas.',
  hsk_enter_next_segment_listen_review: '¿Finalizar la revisión? Tras finalizar, comenzará la sección de lectura.',
  hsk_enter_next_segment_read_tip: 'Tiene {count} preguntas de lectura sin responder,',
  hsk_enter_next_segment_read: '¿Enviar sección de lectura? Tras enviar, no podrá volver a modificar.',
  hsk_enter_next_segment_write_tip: 'Tiene {count} preguntas de escritura sin responder.',
  hsk_enter_next_segment_write: '¿Confirmar envío del examen?',
  hsk_end_preview: 'Finalizar previsualización',
  hsk_submit_listen: 'Enviar Comprensión auditiva',
  hsk_end_review: 'Finalizar revisión',
  hsk_start_exam: 'Inicio',
  hsk_link_test: 'Haz clic para realizar el simulacro oficial',
  hsk_link_tips: 'Realiza simulacros oficiales y obtén certificados oficiales',
  hsk_buy: 'Comprar',
  hsk_test_ready: 'Preparación',
  hsk_test_ready_tips:
    'Esta prueba contiene ejercicios de Comprensión auditiva. Ajuste la configuración de audio según sea necesario. En un momento, reproduciremos un archivo de audio para que verifiques su configuración.',
  hsk_test_content: 'Contenido',
  hsk_test_num: 'No. Preguntas',
  hsk_total_num: 'Total de preguntas',
  hsk_test_time: 'Tiempo',
  hsk_time_total: 'Tiempo total',
  hsk_test_minute: 'mins.',
  hsk_about: 'Sobre',
  hsk_abbreviation: 'Abreviar',
  hsk_determine_ans: '¿Seguro que quieres empezar?',
  hsk_determine_ans_tips:
    'Una vez que comience su respuesta, no podrá volver a ver el texto original.',
  no_data: 'Sin datos',
  hsk_question_number: 'No. Preguntas',
  hsk_test_rate: '% de examen',
  hsk_right_rate: 'Correcto',
  hsk_operation: 'Acciones',
  hsk_skip: 'Saltar',
  hsk_spend: 'Costo',
  hsk_cost: 'Costo',
  hsk_credit: 'Saldo',
  hsk_pay_successfully: 'Pago realizado con éxito',
  hsk_select_amount: 'Seleccionar importe de recarga',
  button_common_ok: 'Confirmar',
  button_common_cancel: 'Cancelar',
  change_lang_ok: 'Confirmar',
  change_lang_cancel: 'Cancelar',
  hint_player_loader_error: 'No se pudo reproducir el audio',
  hint_common_wait_loading: 'Descargando recursos…',
  button_common_hand_in: 'Enviar',
  test_total_question: '{count} preguntas en total',
  test_release: 'Publicar',
  test_off_shelf: 'despublicar',
  test_enable: 'Publicar',
  test_record: 'Registro de simulacros de examen completados',
  test_finish_time: 'Completado',
  test_paper: 'Simulacro de examen',
  test_confirm_use: 'Publicar simulacro de examen',
  test_confirm_off_shelf: 'Despublicar simulacro de examen',
  test_has_on_shelf: 'Disponible',
  test_un_release: 'Sin publicar',
  test_un_enable: 'No disponible',
  test_max_score: 'Puntuación más alta',
  test_average_score: 'Puntuación media',
  test_min_score: 'Puntuación más baja',
  test_all: 'Todo',
  test_has_practiced: 'Revisar',
  test_paper_office: 'El examen ya no está disponible',
  test_complete_introduce: 'Descripción completa',
  test_course_link: 'Cursos oficiales',
  test_about_down_load: 'Descargas',
  test_pay: 'Pagar',
  mark_answer_user: 'Remitente',
  mark_answer_time: 'Tiempo de presentación',
  mark_correct_time: 'Tiempo de evaluación',
  mark_correct_status: 'Estado',
  mark_correct_user: 'Asesor(a) ',
  mark_correct_option: 'Acciones',
  mark_correct_ing: 'Evaluando',
  mark_un_correct: 'No evaluado',
  mark_has_correct: 'Evaluado',
  mark_report_tips:
    'Nota: la parte de Expresión e interacción escrita aún no se ha incluido en la puntuación total. Las preguntas 99-100 serán corregidas por un examinador profesional dentro de las próximas 48 horas. Su puntaje se actualizará inmediatamente aquí y le notificaremos por correo electrónico.',
  mark_report_tips_hskk:
    'Nota: las preguntas del examen serán completadas por un anotador profesional dentro de las 48 horas, y la sucursal general las actualizará simultáneamente después de la finalización de la corrección. en ese momento, le informaremos por correo electrónico.',
  mark_submit_btn: 'Enviar',
  mark_submit_tips: '¿Enviar sus respuestas?',
  mark_back: 'Atrás',
  mark_correct_tips: 'El simulacro de examen actual se está evaluando y no se puede modificar.',
  mark_correct_person: 'Evaluación manual',
  search_user_message: 'Buscar usuario',
  mark_current_user: 'Usuario actual',
  mark_correct_paper: 'Evaluar',
  mark_all_status: 'Todos los estados',
  mark_all_level: 'Todos los niveles',
  mark_overtime: 'Atrasado',
  mark_answer: 'Respuesta',
  home_test_registration: 'Registrarse',
  home_word_outline: 'Programa de estudios',
  home_online_practice: 'Muestra',
  home_test: 'Documentos',
  home_page: 'Inicio',
  common_text_control_speed: 'Velocidad',
  button_common_playback: 'Reproducir grabación',
  common_text_file_error: 'No se pudieron descargar los recursos. Inténtelo de nuevo.',
  common_text_server_error: 'Inténtelo de nuevo',
  common_text_none_network: 'Red inestable',
  button_common_start_over: 'Inténtelo de nuevo',
  evaluating_tips_common:
    'Hay una gran diferencia entre su grabación y el texto. Inténtelo de nuevo.',
  evaluate_common_total_score: 'Puntaje',
  evaluate_common_training_remain: 'Restante:',
  evaluate_common_training_readyRcord: 'Prepárese para grabar',
  evaluate_common_training_atleast: 'La grabación debe durar más de 1 segundo.',
  evaluate_common_training_atleast2: 'La grabación debe durar más de 2 segundos.',
  evaluate_common_training_evaluting: 'Calificación',
  evaluating_tips_additionalAndBack: 'Repetir lectura',
  textbook_chioce_word_text_correct_tip: 'Respuesta correcta. ¡Excelente!',
  textbook_chioce_word_text_error_tip: 'Respuesta incorrecta. ¡Síga intentandolo!',
  textbook_reading_comprehension_stem: 'Comprensión de lectura',
  spc_back_tips: '¿Abandonar? Sus respuestas no se guardarán.',
  spc_level_text: 'Pruebas de nivel',
  spc_capability_assessment: 'Evaluación de su capacidad',
  spc_pick_level: 'Seleccionar nivel',
  spc_listen: 'Comprensión auditiva',
  spc_speak: 'Expresión',
  spc_read: 'Comprensión de lectura',
  spc_write: 'Expresión e interacción escrita',
  spc_translation: 'Traducción',
  spc_result_tips: 'Basado en la prueba, su Chino está en nivel HSK {level}',
  spc_recommend_test: 'Está trabajando hacia HSK {level}',
  spc_recommend_test1: 'Está trabajando hacia <strong> HSK {level}</strong>',
  spc_again_test: 'Prueba nuevamente',
  spc_where_tips: '¿No está seguro/a en qué nivel está?',
  spc_immediate_test: 'Hacer una prueba',
  spc_test_content: 'Contenido de la prueba',
  spc_test_content_desc: 'Se evaluarán las competencias del usuario en cinco dimensiones: comprensión auditiva, expresión oral, lectura (en voz alta), escritura (entrada manual o selección) y traducción. Las preguntas varían según el nivel.',
  spc_test_timer: 'Duración de la prueba',
  spc_test_timer_desc: 'Duración estimada de 15 minutos. A mayor nivel, mayor duración.',
  spc_test_result: 'Resultados de la prueba',
  spc_test_result_desc: 'Ayuda a determinar rápidamente tu nivel y mejorar habilidades específicas',
  vocab_level_word: '{level} Lista de vocabulario',
  vocab_total_item: '{total} elementos en total',
  vocab_search: 'Buscar',
  vocab_all_marked: 'Todo',
  vocab_already_marked: 'Marcado',
  vocab_unmarked: 'No marcado',
  vocabulary: 'Caractéres',
  vocab_pinyin: 'Pinyin',
  vocab_translate: 'Significado',
  vocab_mark: 'Marcador',
  delete_confirmation: '¿Eliminar elemento de vocabulario?',
  cancel: 'Cancelar',
  del: 'Eliminar',
  edit_vocab: 'Editar vocabulario',
  save: 'Guardar',
  add_vocab: 'Añadir vocabulario',
  hanzi: 'Chino',
  num_bihua: 'Trazos',
  write_demo: 'Animación',
  vocab_side: 'Componentes',
  level: 'Niveles',
  see_more: 'Ver más',
  same_read_word: 'Suena igual',
  samilar_read_word: 'Suena similar',
  add_mark: 'Marcador',
  word_team: 'Words',
  instance: 'Oraciones de ejemplo',
  include_num_char: 'Comprende {total} otras palabras de YCT/HSK',
  length_diff: 'El numero de sílabas entre el pinyin y los caractéres chinos no coinciden',
  add_word_success: 'Vocabulario añadido exitosamente',
  add_word_fail: 'Error al agregar vocabulario',
  edit_word_success: 'Vocabulario editado exitosamente',
  edit_word_fail: 'No se pudo editar el vocabulario',
  del_success: 'Eliminado',
  del_fail: 'Error al eliminar',
  mark_free: 'Marcado libremente, Ej. marcado como "dominado"',
  write_word_sentence: 'Por favor, haga una oración basandose en las palabras anteriores...',
  write_word_artical: 'Escriba un breve ensayo basado en las palabras clave anteriores...',
  write_img_artical: 'Por favor escriba un breve ensayo basado en la imagen de arriba...',
  write_artical_title: 'Por favor introduzca su titulo …',
  write_artical_content: 'Por favor escriba su contenido...',
  my_wallet: 'Mi cartera',
  learn_history: 'Ver historia',
  manage: 'Administrar créditos',
  birthday: 'Fecha de nacimiento',
  email: 'Correo electrónico',
  change_pw: 'Cambiar contraseña',
  edit_info: 'Editar detalles',
  lastName: 'Apellidos',
  firstName: 'Primer nombre',
  gender: 'Género',
  female: 'Femenino',
  male: 'Masculino',
  non_disclosure: 'Otro',
  change_avatar: 'Cambiar avatar',
  preview_avatar: 'Previsualizar',
  upload_image: 'Cargar imagen',
  change_image: 'Cambiar imagen',
  enter_old_pw: 'Contraseña anterior',
  enter_new_pw: 'Nueva contraseña',
  enter_new_pw_again: 'Escriba su nueva contraseña nuevamente',
  forget_pw: 'Olvidé la contraseña',
  recharge: 'Recargar',
  left_balance: 'Crédito disponible',
  consume_log: 'Gasto',
  recharge_log: 'Recargas',
  consume_time: 'Fecha / Hora',
  consume_source: 'Créditos gastados en',
  consume_money: 'Créditos',
  total_item_log: '{total} registros en total',
  recharge_time: 'Fecha / Hora',
  recharge_num: 'Créditos',
  recharge_money: 'Cantidad',
  recharge_method: 'Método',
  learn_content: 'Simulacro de examen',
  total_score: 'Total',
  view_result: 'Ver resultados',
  management: 'Administrar créditos',
  give_history: 'Historia',
  total_recharge: 'Recarga total',
  last_login: 'Último acceso',
  give: 'Enviar créditosditos a',
  gifted: 'Enviar créditosditos a',
  give_time: 'Fecha / Hora',
  give_to_person: 'Destinatario/a',
  opera_person: 'Otorgados por',
  give_to: 'Enviar créditos a',
  old_password_empty: 'El campo de contraseña anterior no se puede dejar vacío',
  diff_password: 'Las contraseñas no concuerdan',
  change_pw_success: 'La contraseña ha sido actualizada',
  change_pw_fail: 'No se pudo cambiar la contraseña',
  change_info_success: 'Información actualizada exitosamente',
  change_info_fail: 'No se pudo actualizar la información',
  statistics_center: 'Ver estadísticas',
  select_recharge_mount: 'Seleccione la cantidad de recarga',
  waiting_pay: 'Pago pendiente ...',
  has_no_resolve_credit: 'Pago fallido, por favor inténtalo de nuevo.',
  complete_pay: 'Pago completado',
  pay_fail: 'Pago fallido',
  give_success: 'Créditos otorgados con éxito',
  give_fail: 'Error al dar créditos',
  change_avatar_success: 'Avatar actualizado exitosamente',
  change_avatar_fail: 'No se pudo actualizar el avatar',
  enter_family_name: 'Apellidos',
  enter_given_name: 'Primer nombre',
  log_in: 'Iniciar sesión',
  log_in_error: 'Error al iniciar de sesion',
  email_address: 'Correo electrónico',
  invalid_email_address: 'No es un formato de correo electrónico válido',
  password: 'Contraseña',
  password_tip: 'La contraseña debe tener entre 6 y 20 caracteres',
  invalid_password: 'Formato de contraseña incorrecto',
  have_account: 'Ya tengo una cuenta',
  sign_up: 'Registrarse',
  sign_up_error: 'Registro fallido',
  forget_pw_success:
    'El correo electrónico para el restablecimiento de su contraseña ha sido enviado exitosamente',
  forget_pw_error: 'No se pudo enviar el correo electrónico para el restablecimiento de contraseña',
  loading: 'Cargando',
  account_block: 'Esta cuenta está deshabilitada',
  account_block_tip:
    'Comuníquese con un agente en su escuela u organización para obtener más información.',
  resend_email: 'Reenviar correo electrónico',
  resend_email_success: 'Correo electrónico reenviado con éxito',
  resend_email_error: 'No se pudo reenviar el correo electrónico',
  i_am: 'Soy',
  choose_role: '¿Cuál opción le describe mejor?',
  choose_role_error: 'Error al seleccionar rol',
  continue: 'Continuar',
  learner: 'Estudiante',
  learner_description: 'Estoy aprendiendo chino',
  teacher: 'Docentes',
  teacher_description: 'Estoy enseñando chino',
  setup_account_error: 'Error al configurar la cuenta',
  tos_link: 'Términos de Uso',
  privacy_link: 'Política de privacidad',
  email_verified: '¡Correo Electrónico Verificado!',
  email_verified_tip: 'Gracias por verificar su e-mail.',
  email_verified_error: 'No se pudo verificar su cuenta',
  something_wrong: 'Algo salió mal',
  retry: 'Inténtelo de nuevo',
  guardian_consent_error: 'Consentimiento fallido',
  about_us: 'Acerca de Nosotros',
  about_us_new: 'Acerca de Nosotros',
  feedback: 'Contáctanos',
  download: 'Descargar',
  submit: 'Enviar',
  feedback_success: 'Enviado exitosamente',
  feedback_error: 'fallo al enviar',
  logout: 'Cerrar sesión',
  my_account: 'Mi cuenta',
  login_signup: 'Iniciar sesión / Registrarse',
  please_enter_content: 'Su mensaje (requerido)',
  describe_detail: 'Si está describiendo un error, proporcione tantos detalles como pueda.',
  upload_picture:
    'Cargue hasta {maxFiles}x jpg/png imagenes (opcional), max. 2MB para cada imagen.',
  file_error: 'El archivo tiene un formato incorrecto o es demasiado grande',
  file_num_limit: 'Número máximo de subidas: {maxFiles} archivos',
  sure_change_lang: '¿Cambiar idioma?',
  privacy_policy_text1: 'HSK Mock.com — la única plataforma de simulación certificada por Chinese Testing International',
  privacy_policy_text2: 'La plataforma de simulación ha sido desarrollada y operada conjuntamente por Wo Hui y Chinese Testing International, basada en bancos de preguntas HSK y YCT. Ofrece simulacros completos para apoyar a los estudiantes en exámenes estandarizados de chino.',
  privacy_policy_text3: 'Wo Hui Mandarin es socio oficial de Chinese Testing International.',
  privacy_policy_text4: 'Chinese Testing International Education Technology (Beijing) Co., Ltd. es una institución especializada en servicios de evaluación internacional del chino, dedicada a proporcionar investigación, desarrollo tecnológico, implementación de exámenes y promoción global para satisfacer las necesidades de estudiantes e instituciones.',
  privacy_policy_text5: 'Wo Hui fue fundada en 2018 en Singapur por EiM International Education Group. Es una empresa independiente dedicada a proporcionar soporte tecnológico y servicios de plataforma para el aprendizaje del chino a estudiantes de todo el mundo. Ofrece cursos diversos para diferentes estudiantes, así como abundantes recursos didácticos y herramientas prácticas para docentes.',
  privacy_policy_text6: 'Chinese Testing International y Wo Hui mantienen una sólida colaboración estratégica para promover el aprendizaje del chino, ofreciendo evaluación precisa, aprendizaje personalizado y simulación del entorno real de examen.',
  level_test: 'Pruebas de nivel',
  level_test_example:
    'Si no está seguro en qué nivel se encuentra, realice una breve prueba gratuita para averiguar en qué nivel de examen debe trabajar a continuación.',
  download_app_mobile: 'Para una mejor experiencia, accede a hskmock.com desde un ordenador o descarga la app para usarla.',
  common_video_failed: 'No se pudo cargar el audio',
  member_error: '¡Algo salió mal con éste recurso!',
  agree_policy:
    'He leído y acepto los <u class="strong"><a href="{url}" target="_blank">Términos de servicio</a></u> y la <u class="strong"><a href="{userUrl}" target="_blank">Política de privacidad</a></u>',
  please_check: 'Por favor lea y acepte los Términos de servicio y la Política de privacidad',
  media_devices_unsupported_browserLabel:
    'Se recomienda Google Chrome como navegador predeterminado. Método de configuración (tomando Windows 10 como ejemplo): Configuración-Aplicación-Aplicación predeterminada-Navegador web-seleccione Google Chrome',
  media_devices_help_title: '¿Activar micrófono?',
  media_devices_help_content: 'Debe activar el micrófono para grabar audio',
  batch_exist_user: '{number} registrado(s)',
  batch_and: 'y',
  batch_un_exist_user: '{number} sin registrar',
  batch_from: 'De',
  batch_notes: 'Notas',
  batch_something: 'Escribe algo',
  batch_people_number: 'Destinatarios',
  batch_use_number2: 'Costo',
  batch_operation_status: 'Estado',
  batch_ing_status: 'En progreso',
  batch_success: 'Superado',
  batch_failed: 'Fallido',
  batch_select: 'Seleccionar',
  common_to: 'Para',
  common_start_time: 'Comienzo',
  common_end_time: 'Fin',
  batch_search_tips:
    'Separe varias direcciones de correo electrónico con una coma, hasta 50 correos electrónicos a la vez.',
  common_un_exist: 'No registrado',
  common_invalid: 'Inválido',
  batch_all_give: 'Dar creditos a todos',
  batch_single_people: 'Personal',
  batch_all: 'Lote',
  batch_name: 'Nombre',
  batch_added_credits: 'Créditos añadidos',
  batch_spent_credits: 'Créditos gastados',
  batch_account_status: 'Estado de la cuenta',
  batch_Added_total: 'Total agregado',
  batch_spent_total: 'Gasto total',
  batch_Remaining: 'Restante',
  batch_Recipients: 'Destinatario/a',
  batch_Active: 'Activo',
  batch_search: 'Buscar',
  certificate_details: 'Detalles del certificado',
  get_official_mock_certificate: 'Obtener certificado oficial de simulación',
  certificate_tips: 'Los datos del certificado se obtienen de su información personal. Por favor, verifique que sean correctos:',
  country: 'Nacionalidad',
  select_country: 'Seleccione nacionalidad',
  email_to: 'El certificado se enviará por correo electrónico a:',
  polyphonic: 'Carácter polisémico',
  click_tips: 'Haga clic en el número de la pregunta para ver la respuesta',
  download_tips: 'Al aprobar, podrá descargar el certificado de simulación',
  cancel_delete_account: 'Cerrar cuenta',
  cancel_confirm: 'Confirmar',
  user_apply_delete_account_title: 'Solicitar eliminación de cuenta',
  user_apply_delete_account_confirm_tip: 'Confirme su información de acceso',
  user_apply_delete_account_alwaysTip: 'Está solicitando la eliminación permanente de su cuenta y datos personales.',
  user_apply_delete_account_confirm_tip2: 'Antes de enviar la solicitud, confirme su identidad.',
  user_apply_delete_account_desc:
    'Su cuenta {email} se utiliza para acceder a <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> y <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2: 'Tras la eliminación, no podrá volver a acceder a estas aplicaciones.',
  user_apply_delete_account_wohui_title: 'Cancelar suscripción de Wo Hui',
  user_apply_delete_account_hsk_title: 'Saldo de HSK Mock',
  user_apply_delete_account_next_tip: 'Haga clic en "Siguiente" para confirmar que ha leído y aceptado lo anterior.',
  user_apply_delete_account_next_title: 'Siguiente',
  user_apply_delete_account_confirm_tip11: 'Cancele su suscripción antes de completar la eliminación de la cuenta',
  cancel_delete_ok: 'De acuerdo',
  cancel_delete_request_send: 'Enviar solicitud',
  user_apply_delete_account_confirm_tip8: 'Cuando su suscripción expire el {date}, su cuenta será eliminada permanentemente',
  user_apply_delete_account_confirm_tip4: 'Enviaremos un correo a',
  user_apply_delete_account_confirm_tip5: 'para confirmar que su cuenta ha sido eliminada',
  user_apply_delete_account_confirm_tip6: 'Para cancelar su solicitud, haga clic en "Cancelar"',
  user_apply_delete_data_always: '¿Desea cancelar la solicitud de eliminación permanente de su cuenta y datos?',
  cancel_delete_yes: 'Confirmar',
  cancel_delete_no: 'Cancelar',
  user_cancel_delete_success: 'Hemos cancelado su solicitud. Su cuenta de HSK Mock no será eliminada.',
  user_cancel_subscribe_again: 'Puede suscribirse nuevamente.',
  user_apply_delete_account_confirm_tip9: 'La fecha de vencimiento de su suscripción es',
  user_apply_delete_account_confirm_tip10: 'Seleccione la fecha en la que desea eliminar su cuenta',
  user_apply_delete_account_ok_btn_title: 'Fecha de expiración de la suscripción',
  user_apply_delete_account_now_btn_title: 'Eliminar inmediatamente',
  cancel_out_subscription_abnormal: 'Error en la información de suscripción del usuario',
  user_apply_delete_account_confirm_tip3:
    'Tiene una suscripción en Apple que se renovará automáticamente. Cancele su suscripción antes de la renovación',
  user_apply_delete_stripe_tip:
    'Su suscripción de Stripe se cobrará automáticamente en su tarjeta. Por favor, acceda a nuestro sitio web',
  user_apply_delete_account_balance: 'Su saldo es',
  user_apply_delete_account_balance_tip: 'Una vez eliminada la cuenta, el saldo no será reembolsado.',
  user_apply_delete_account_expire: 'Su cuenta será eliminada en un plazo de tres días',
  my_class_name: 'Mis clases',
  my_class_search: 'Buscar clases',
  my_class_total: 'Total',
  my_class_people: 'Personas',
  my_class_ci: 'Participaciones',
  my_class_number: 'Número de personas',
  my_class_ci_number: 'Número de veces',
  my_class_tips: 'Círculo interno: proporción de HSK y YCT',
  my_class_tips1: 'Círculo externo: distribución por niveles de HSK y YCT',
  my_class_all_class: 'Todas las clases',
  follow_lesson: 'Ver cursos',
  real_paper: 'Realizar simulación oficial',
  start_answer: 'Empezar a responder',
  edit_message_date: 'Fecha',
  edit_message_language: 'Idioma',
  edit_message_zh: 'Chino',
  edit_message_en: 'Inglés',
  edit_message_title: 'Título',
  edit_message_content: 'Introduzca el contenido',
  edit_message_show: 'Mostrar',
  edit_message_save_success: '¡Guardado correctamente!',
  edit_message_create_success: '¡Creado correctamente!',
  edit_message_edit1: 'Editar',
  edit_message_follow_notice: 'Ver notificaciones',
  edit_message_textarea_tips: 'Si añade un enlace, añada un espacio después del enlace para distinguirlo',
  edit_message_notifications: 'Editar notificación',
  edit_message_Send_time: 'Fecha de envío',
  edit_message_edit_notification: 'Editar notificación',
  edit_message_add: 'Añadir notificación',
  edit_message_from: 'Fecha de inicio',
  edit_message_to: 'Fecha de fin',
  edit_message_new_add: 'Añadir notificación',
  currency: 'Selección de moneda',
  pay_failed: '¿La página no se ha cargado correctamente?',
  pay_un_finished: 'No se pudo completar el pago',
  select_currency_tips: 'Si lo desea, puede seleccionar otra moneda en la lista desplegable inferior',
  change_currency_tips: 'Puede cambiar la moneda en cualquier momento en "Mi cuenta"',
  my_homework: 'Mis tareas',
  my_homework_add: 'Asignar tareas',
  my_homework_all_classes: 'Todas las clases',
  my_homework_paper: 'Nombre del examen',
  my_homework_sent_to: 'Enviar',
  my_homework_sent_on: 'Fecha de envío',
  my_homework_due_on: 'Fecha límite',
  my_homework_submitted_assignees: 'Entregados / enviados',
  my_homework_class_hint: 'El icono junto al nombre de la clase indica asignación parcial',
  my_homework_delay_hint: 'Permitir que los usuarios entreguen después de la fecha y hora límite establecidas',
  my_homework_add_send_assignment: 'Enviar tarea',
  my_homework_add_new_assignment: 'Nueva tarea',
  my_homework_edit_assignment: 'Editar tarea',
  my_homework_add_assignment: 'Añadir tarea',
  my_homework_add_assignment_details: '1. Detalles de la tarea',
  my_homework_add_issue_time: 'Fecha de publicación',
  my_homework_add_whether_submit: 'Permitir entregas después de la fecha límite',
  my_homework_add_note: 'Notas',
  my_homework_add_assignees: '2. Destinatarios',
  my_homework_edit_add_assignees: 'Destinatarios',
  my_homework_add_group: 'Seleccionar clase',
  my_homework_add_immediate_release: 'Publicar ahora',
  my_homework_add_time_release: 'Publicación programada',
  my_homework_add_are: 'Sí',
  my_homework_add_no: 'No',
  my_homework_detail_back: 'Volver a mis tareas',
  my_homework_detail_sent_to: 'Enviado a',
  my_homework_detail_leamers_in: 'estudiantes, en',
  my_homework_detail_on: 'en',
  my_homework_detail_to_complete_by: 'Enviado el',
  my_homework_detail_add_assignee: 'Añadir destinatarios',
  my_homework_detail_assignee: 'Destinatarios',
  my_homework_search_placeholder: 'Introduce el contenido de búsqueda',
  my_homework_stu_sent_by: 'Remitente',
  my_homework_total_topic_count: 'Total de {count} preguntas',
  my_homework_time_full: '{min} minutos',
  my_homework_select_date_time: 'Seleccionar fecha y hora',
  my_homework_delete_assignment_title: 'Eliminar tarea',
  my_homework_delete_assignment_tips: '¿Confirmar eliminación de la tarea? Esta acción no se puede deshacer.',
  my_homework_assignment_add_fail: '¡Error al publicar!',
  my_homework_assignment_add_success: '¡Publicado correctamente!',
  my_homework_assignment_edit_success: '¡Editado correctamente!',
  my_homework_assignment_edit_fail: '¡Error al editar!',
  my_homework_assignment_delete_fail: '¡Error al eliminar!',
  my_homework_assignment_delete_success: '¡Eliminado correctamente!',
  my_homework_assignment_due_on: 'Fecha límite',
  my_homework_assignment_product: 'Nombre del producto',
  my_homework_assignment_certificate: 'Certificado',
  my_homework_assignment_reset: 'Restablecer',
  my_homework_assignment_reset_title: '¿Restablecer el módulo seleccionado?',
  my_homework_assignment_gifted: 'Cantidad a regalar',
  my_homework_assignment_papers: 'exámenes',
  my_homework_assignment_send_to: 'Tarea enviada a',
  my_homework_assignment_close_tip: 'Los cambios no se han guardado. ¿Confirmar salida?',
  pay_callback_tips:
    'Si utiliza Alipay o WeChat Pay para comprar simulacros, acceda al sitio de China continental: hskmock.cn',
  no_available_class: 'No hay clases disponibles',
  payment_method: 'Método de pago',
  wechat_pay: 'Pago con WeChat',
  alipay_payment: 'Pago con Alipay',
  card_payment: 'Pago con tarjeta de crédito',
  card_payment_description: 'Solo tarjetas internacionales',
  payment_to_wohui: 'Pago a Wo Hui Technology (Shanghai) Co., Ltd.',
  order_submitted: '¡Pedido realizado con éxito. Por favor, complete el pago!',
  order_number: 'Número de pedido:',
  code_expires:
    'Tiempo restante antes de que expire el código QR: <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: 'Utilice WeChat para escanear el código QR y pagar',
  code_expired: 'El código QR ha expirado',
  amount_payable: 'Importe a pagar:',
  use_code: 'Usar código de canje',
  tests: 'Historial de exámenes',
  level_title: '¿Cuál es tu nivel objetivo?',
  level_des:
    'Si no estás seguro, puedes realizar una <b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">prueba de nivel gratuita ></b>',
  level_HSK_text1: '<b>HSK</b> es la abreviatura en pinyin de "Examen de Nivel de Chino", que significa examen de competencia en chino.',
  level_HSK_text2: 'Es el examen de chino más popular del mundo.',
  level_YCT_text1: '<b>YCT</b> es la abreviatura en inglés de "Youth Chinese Test".',
  level_YCT_text2: 'Es un examen de chino dirigido a estudiantes de primaria y secundaria.',
  level_BEGINNER: 'Nivel inicial',
  level_INTERMEDIATE: 'Nivel intermedio',
  level_ADVANCED: 'Nivel avanzado',
  level_dialog_title: 'Prueba de nivel',
  level_dialog_content:
    'La prueba de nivel gratuita dura aproximadamente 15 minutos. Los resultados mostrarán tu nivel actual de HSK y el grado de correspondencia en las cuatro habilidades lingüísticas (comprensión auditiva, lectura, escritura y expresión oral).',
  level_dialog_login: 'Iniciar sesión / Registrarse',
  level_dialog_start: 'Empezar prueba de nivel',
  about_us_first_paragraph:
    '<b>HSK Mock</b> es la plataforma oficial única de simulación para los exámenes HSK y YCT, los más populares del mundo. Es un producto desarrollado conjuntamente por <b>Chinese Testing International</b> y <b>Wo Hui Mandarin</b>',
  about_us_second_paragraph:
    '<b>Chinese Testing International</b> (CTI) es el organismo examinador de HSK y YCT. Es una empresa con sede en Pekín que promueve y apoya el aprendizaje, la enseñanza y la evaluación del chino como lengua extranjera a nivel global.',
  about_us_third_paragraph:
    '<b>Wo Hui Mandarin</b> ofrece la plataforma oficial en línea para cursos y exámenes HSK y YCT. Es una empresa con sede en Singapur que utiliza la tecnología para facilitar el aprendizaje autónomo y capacitar a los docentes en el acompañamiento del estudiante.',
  about_us_cti_text: 'Más información:',
  about_us_wohui_text: 'Si desea obtener más información, contáctenos:',
  listening_section: 'Sección de comprensión auditiva',
  reading_section: 'Sección de lectura',
  writing_section: 'Sección de escritura',
  review_answers: 'Revisar respuestas',
  characters_long: 'Si aún no tiene cuenta, establezca una contraseña de 6 a 20 caracteres.',
  complete_profile: 'Completar perfil',
  verify_email: 'Verificar tu correo electrónico',
  link_sent: 'Gracias por registrarte. Haz clic en el enlace enviado a tu correo electrónico para verificar tu dirección:',
  resend_link: 'Reenviar enlace >',
  restart: 'Reiniciar',
  parental_consent: 'Consentimiento parental',
  sent_parental: 'Gracias por registrarte. Sigue las instrucciones enviadas por correo electrónico para obtener el consentimiento de tus padres o tutores:',
  thank_you: '¡Gracias!',
  or_return: 'O volver a la aplicación',
  child_profile: 'Perfil de su hijo/a',
  sign_up_privacy:
    'He leído y acepto los <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">Términos de servicio</a> y la <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">Política de privacidad</a>',
  give_consent: 'Acepto',
  delete_child_details: 'Eliminar los datos del menor',
  account_created: 'Cuenta creada con éxito',
  emailed_know: 'Hemos enviado un correo electrónico a <span style="font-weight: 700">{email}</span> para informarle.',
  account_deleted: 'Eliminar cuenta',
  child_know_deleted: 'Informe a su hijo/a de que sus datos han sido eliminados.',
  request_email:
    'La información anterior (excepto el correo electrónico) puede actualizarse después de iniciar sesión. Por favor, autorice la creación de la cuenta de su hijo/a; de lo contrario, solicite la eliminación de sus datos.',
  preferred_currency: 'Moneda preferida',
  parent_guardian: 'Padre/Madre o Tutor',
  class_name: 'Nombre de la clase',
  tofficial_platform: 'Plataforma oficial única de simulación del examen HSK',
  proficiency_tests: 'Prepárate para el examen de chino más popular del mundo',
  get_started: '开始',
  platform_china: 'También ofrecemos servicios de simulación de examen para candidatos en China continental.',
  take_confidence: 'Asegura tu éxito en el examen HSK',
  practice_tests: 'Práctica intensiva para HSK y YCT',
  using_time:
    'Utiliza los últimos exámenes oficiales proporcionados por Hanban para familiarizarte con los tipos de preguntas, dominar los requisitos del examen y mejorar la velocidad de respuesta.',
  instant_results: 'Obtén retroalimentación inmediata',
  each_test_question:
    'Revisa cada pregunta completada, consulta tu puntuación, el análisis detallado y las respuestas correctas, identifica errores y mejora tu rendimiento.',
  track_progress: 'Registro del progreso',
  ready_next_test:
    'La plataforma registra automáticamente la fecha, hora, evolución de habilidades y cambios de puntuación en cada simulación, ayudándote a identificar el mejor momento para presentar el examen real.',
  receive_official_certificates: 'Obtén certificados oficiales de simulación',
  certificates_provide_evidence:
    'Se emiten certificados por cada simulación aprobada, acreditando tu nivel de chino.',
  ready_next_level: 'Avanza al siguiente nivel',
  check_description:
    'Consulta la descripción del siguiente nivel, revisa los requisitos y normas del examen, estudia el vocabulario requerido y familiarízate con el contenido y las estrategias del examen.',
  on_the_move: '¿Uso en móvil?',
  download_mobile: 'Haz clic en el siguiente botón para descargar la app móvil',
  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span> es el examen de nivel de chino más popular del mundo. Desde básico hasta avanzado, cuenta con 9 niveles.',
  more: 'Más información',
  ytc_beginner_advanced:
    '<span style="font-weight: 700">YCT</span> es un examen de nivel de chino dirigido a estudiantes de primaria y secundaria. Cuenta con 4 niveles desde básico hasta intermedio.',
  coming_end: 'Simulación de examen oral disponible desde finales de 2023',
  candidates_proficiency_speaking: 'Evalúa la capacidad de expresión oral en chino.',
  level_oral_tests:
    '<span style="font-weight: 700">HSKK</span> es el examen de competencia oral en chino.',
  check_test_dates: 'Consultar fechas de examen',
  book_test: 'Inscribirse en el examen',
  international_platform:
    'Nuestra plataforma en China está ubicada en China continental; la plataforma internacional está ubicada en Singapur. Ambas plataformas son independientes. Elige la que mejor se adapte a ti.',
  mock_platform: 'Plataforma oficial de simulación del examen',
  home_proficiency_tests: 'Prepárate para el examen de chino más popular del mundo',
  currency_type: 'Selección de moneda',
  Pick_your_level: 'Elige tu nivel de HSK',
  About_this_level: 'Descripción de niveles',
  test_session: 'prueba',
  Learning_resources: 'Recursos de aprendizaje',
  Take_practice_test: 'Examen de simulación',
  Compare_syllabuses: 'Comparación de programas',
  table_shows_syllabuses: 'Esta tabla muestra los niveles del HSK según diferentes programas.',
  forrgin_lang: '0547 corresponde a “chino como lengua extranjera”',
  Second_Language: '0523 corresponde a “chino como segunda lengua”',
  Requirement_entry: 'Requisitos de registro',
  most_Chinese_universities: 'La mayoría de las universidades chinas',
  Qing_Hua: 'Universidad de Tsinghua',
  beijing_university: 'Universidad de Pekín',
  working_towards: 'Tras la evaluación, se recomienda preparar',
  On: 'en',
  Level_test: 'Prueba de nivel',
  Retake_level_test: 'Repetir examen',
  practice_test: 'Realizar una práctica de examen',
  Compare_syllabuses_a: 'Comparación entre diferentes planes de estudio y el programa del HSK',
  Not_sure: '¿No estás seguro de tu nivel?',
  free_level_test: 'Realiza una prueba de nivel gratuita',
  Examples: 'Ejemplo de pregunta',
  product_code: 'Código de canje del producto',
  enter_paper: 'Introduce un código de canje (cada código es de un solo uso)',
  no_code: '¿No tienes un código? Adquiérelo a través de nuestros socios:',
  to_partner: 'Ir al enlace del socio',
  code_here: 'Introduce el código aquí',
  start_assigment: 'Empezar',
  view_assigment: 'Ver resultados',
  continue_assigment: 'Continuar',
  choose_method: 'Seleccionar método de desbloqueo',
  choose_new_method: 'Selecciona el método para desbloquear nuevas pruebas.',
  browser_layer: 'Utilice Google Chrome en PC o la app en dispositivos móviles',
  partner_title1: 'Esperamos que se convierta en',
  partner_title2: 'Socio local',
  company_name: 'Nombre de la empresa',
  company_website: 'Sitio web de la empresa',
  teachers_count: 'Número de docentes de HSK colaboradores',
  learners_count: 'Número de estudiantes de HSK colaboradores',
  add_msg: 'Déjanos un mensaje',
  contact_style: '¿Cómo podemos contactarte?',
  send: 'Enviar',
  partner_forms_desc:
    'Como socio local, será el principal punto de contacto para candidatos, docentes, escuelas y universidades en su país o región.<br><br>Nuestros socios suelen ser centros consolidados de examen y formación HSK que buscan ampliar su negocio y reforzar su reconocimiento oficial.<br><br>Si desea convertirse en socio local, utilice su cuenta personal de HSK Mock para <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">iniciar sesión</span> y complete la siguiente información. Nos pondremos en contacto con usted lo antes posible.',
  submit_success: 'Envío exitoso',
  help_students_for_testing: '¿Está ayudando a estudiantes a prepararse para el examen?',
  help_students_for_testing_desc:
    'Los docentes desempeñan un papel clave en ayudar a los estudiantes a alcanzar el siguiente objetivo de examen.<br>HSK Mock permite a los docentes ofrecer apoyo de aprendizaje personalizado a los estudiantes.',
  become_partner: 'Conviértete en nuestro socio local',
  become_partner_desc:
    'Para los candidatos, es posible contactar con centros locales en su propio idioma para consultar detalles del examen y utilizar métodos de pago locales preferidos.',
  partnership: 'Explorar colaboración',
  students_forward: 'Apoya a tus estudiantes',
  hsk_confidence: 'Asegura tu éxito en el examen HSK',
  try_it_out: 'Probar ahora',
  walk_through: 'Familiarización con el proceso del examen',
  teachers_page_desc1:
    'Las funcionalidades de la plataforma no solo permiten la enseñanza en grupo, sino también la enseñanza individual. Ayudan a los estudiantes a familiarizarse con los tipos de preguntas, repasar el vocabulario requerido, conocer el contenido del examen y dominar estrategias de examen.',
  assign_practice_papers: 'Establecer fecha y hora límite de entrega',
  teachers_page_desc2:
    'Publica los exámenes para tus estudiantes. Puedes utilizar los simulacros como exámenes formales para que los estudiantes se familiaricen con los diferentes tipos de preguntas del HSK y completen cada sección dentro del tiempo establecido.',
  get_instant_results: 'Retroalimentación inmediata de resultados',
  teachers_page_desc3:
    'No se requiere corrección manual por parte del docente. Puedes verificar si los estudiantes han completado los exámenes asignados y consultar los resultados de cada prueba.',
  review_their_answers: 'Revisión del desempeño del estudiante',
  teachers_page_desc4:
    'Permite analizar en detalle los resultados por clase, habilidad, sección e incluso por pregunta. Al revisar el desempeño, podrás diseñar estrategias pedagógicas y ofrecer retroalimentación personalizada.',
  track_prog: 'Seguimiento del progreso del estudiante',
  teachers_page_desc5:
    'Registra detalladamente los resultados de cada examen, el desempeño por pregunta y la evolución de habilidades y puntuaciones. Estos datos ayudan a los docentes a determinar el mejor momento para que el estudiante presente el examen real.',
  students_next_level: 'Impulsa a los estudiantes al siguiente nivel',
  teachers_page_desc6:
    'Nuestra plataforma asociada ofrece materiales oficiales de HSK y YCT, así como herramientas y recursos educativos que permiten a los docentes proporcionar apoyo de aprendizaje personalizado.',
  teaching_resources: 'Recursos didácticos',
  for_teachers: 'Docentes',
  teachers_desc1:
    'Por favor, utilice su cuenta personal para <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">iniciar sesión</span> en la plataforma de simulación HSK Mock.',
  teachers_desc2: 'Complete la información básica a continuación para habilitar una prueba gratuita para su institución.',
  school_name: 'Nombre de la institución',
  school_web: 'Sitio web de la institución',
  num_of_hsk_teachers: 'Número de docentes de HSK',
  num_of_hsk_learners: 'Número de estudiantes de HSK',
  hsk_submit_reading: 'Comprensión de lectura',
  pay_tip: 'Si deseas pagar con Alipay o WeChat Pay para adquirir simulacros, utiliza nuestro sitio de servicio en China: hskmock.cn.',
  use_pc_or_app: 'Para una mejor experiencia, accede a hskmock.com desde un ordenador o descarga la app.',
  download_certificate: 'Descargar certificado',
  create_certificate: 'Generar certificado',
  certificate_is_downloaded: 'Certificado descargado',
  pay_discount_title: '¿Cuántas veces desea adquirir el simulacro oficial del nivel {level}?',
  total: 'Total',
  pay: 'Pagar',
  price_desc:
    'Solo debe pagar por los simulacros oficiales. Si compra múltiples intentos, obtendrá un descuento por prueba.',
  the_level: 'Nivel',
  discounted_price: 'Precio',
  price_contact_us:
    'También ofrecemos compras al por mayor para instituciones. <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">Contáctenos</span> para más detalles.',
  get_a_discount: 'Obtener descuento',
  finished_pay_discount_title: 'A continuación se muestran sus códigos de canje para el simulacro del nivel {level_name}:',
  btn_goto_papers: 'Ver examen {level_name}',
  test_count: '{test_num} pruebas',
  unit_price: '{price} por prueba',
  buy_code_tip:
    'Hemos enviado estos códigos por correo electrónico. Seleccione el examen {level_name} e introduzca el código para desbloquearlo.',
  discount_codes_left_tip:
    'Después de la prueba, le quedarán <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count}</span> códigos disponibles en este nivel.',
  manage_class: 'Gestionar clases',
  to_manage_class: 'El sistema de gestión de clases se abrirá en una nueva pestaña. Al finalizar, regrese a esta página y actualícela.',
  code_used: 'Usado',
  code_can_be_used: 'No usado',
  no_test: 'Cantidad',
  history_purchase_quantity: 'Cantidad',
  hsk_listen_part_title: 'Comprensión auditiva: Parte {count}',
  hsk_read_part_title: 'Comprensión de lectura: Parte {count}',
  hsk_write_part_title: 'Expresión e interacción escrita: Parte {count}',
  Description: 'Introducción',
  Test_format: 'Estructura del examen',
  Vocabulary: 'Vocabulario',
  vocab_type: 'Categoría gramatical',

  // SSO Login
  sso_login_signup: 'Iniciar sesión / Registrarse',
  sso_email_address: 'Correo electrónico',
  sso_password: 'Contraseña',
  sso_characters_long: 'Si aún no tiene cuenta, establezca una contraseña de 6 a 20 caracteres.',
  sso_forget_pw: '¿Olvidaste tu contraseña?',
  sso_agree_policy: 'He leído y acepto los <u class="strong"><a href="{url}" target="_blank">Términos de servicio</a></u> y la <u class="strong"><a href="{userUrl}" target="_blank">Política de privacidad</a></u>',
  sso_continue: 'Continuar',
  sso_please_check: 'Por favor marque la casilla para aceptar el Acuerdo de usuario y la Política de privacidad',
  sso_invalid_email_address: 'Dirección de correo electrónico no válida',
  sso_invalid_password: 'Formato de contraseña incorrecto',
  sso_loading: 'Cargando',
  sso_mock_platform: 'Plataforma oficial de simulación del examen',
  sso_home_proficiency_tests: 'Prepárate para el examen de chino más popular del mundo',
  sso_guardian_consent_error: 'Operación fallida',
  sso_forget_pw_success: 'Correo de restablecimiento de contraseña enviado correctamente',
  sso_forget_pw_error: 'Error al enviar el correo de restablecimiento de contraseña',
  sso_log_in_error: 'Error de inicio de sesión',
  sso_download_app_mobile: 'Para una mejor experiencia, accede a hskmock.com desde un ordenador o descarga la app para usarla.',
  sso_no_binding_info_tip: 'No se pudo obtener su información',
  sso_third_login_tip: 'Seleccione el sitio que desea abrir',
  sso_third_login_wohui: 'Ir a Wo Hui Mandarin',
  sso_third_login_mock: 'Ir a HSK Mock',

  // Other
  other_gender: 'Confidencial / Otro',
  hsk_enter_listening: 'Comprensión auditiva',
  intro_msg_first: 'Este examen consta de {num} partes que deben completarse en orden.',
  intro_msg_second: 'Complete cada sección dentro del tiempo establecido.',
  intro_msg_third: 'Si ya ha completado las preguntas de esta sección pero aún no ha llegado el tiempo límite, puede pasar a la siguiente parte del examen, pero no podrá volver a las secciones anteriores para continuar respondiendo.',
  dialogue_listening: 'La primera parte es el examen de comprensión auditiva. Haga clic en el botón para reproducir el audio de prueba a continuación y ajuste su dispositivo según sea necesario.',
  dialogue_listening_hskk: 'Haga clic en el botón para reproducir el audio de prueba a continuación y ajuste su dispositivo según sea necesario.',
  dialogue_intro_msg_first: 'Mientras se reproduce la música, seguirá una introducción general al examen. Mientras se reproduce esta introducción, puede previsualizar las preguntas de la sección de comprensión auditiva.',
  dialogue_intro_msg_first_hskk: 'Mientras se reproduce la música, seguirá una introducción general al examen.',
  dialogue_intro_msg_second: 'Para simular el examen real, no puede pausar, rebobinar ni avanzar rápidamente el audio de la sección de comprensión auditiva.',
  dialogue_intro_msg_second_hskk: 'Para simular el examen real, no puede pausar, rebobinar ni avanzar rápidamente.',
  dialogue_intro_msg_third: 'Una vez que termine el audio de la sección de comprensión auditiva, tendrá {duration} minutos para revisar sus respuestas.',
  dialogue_intro_question: '¿Tiene algún problema?',
  dialogue_preload_intro_first: 'El audio de la sección de comprensión auditiva se está descargando.',
  dialogue_preload_intro_second: 'Una vez completada la descarga, el audio se reproducirá automáticamente para comenzar la prueba.',
  dialogue_preload_intro_third: '¡Buena suerte!',
  dialogue_preload_title: 'Descargando recursos del examen',
  mock_paper_preview: 'Vista previa del simulacro de examen',
  dialogue_mock_paper_intro_title: 'Instrucciones del examen',
  dialogue_mock_paper_intro_sentence1: 'Este examen tomará aproximadamente {minutes} minutos. Asegúrese de tener suficiente tiempo y batería para completar el examen de una sola vez.',
  dialogue_mock_paper_intro_sentence2: 'Este examen se realiza completamente en línea, así que asegúrese de tener una conexión a internet estable.',
  dialogue_mock_paper_intro_sentence3: 'Si está usando una computadora de escritorio o portátil, use la última versión del navegador Chrome o Safari.',
  dialogue_mock_paper_intro_sentence4: 'Si está usando una tablet, use nuestra aplicación móvil en lugar del navegador web.',
  dialogue_mock_paper_intro_sentence5: 'Durante el examen, no abra otras ventanas del navegador ni aplicaciones móviles, no cambie de idioma ni conecte/desconecte otros dispositivos (como unidades USB, auriculares, etc.).',
  diologue_mock_paper_quit: 'Salir',
  dialogue_mock_paper_intro_button: 'He leído y entendido',
  deadline_passed: 'La fecha límite ha pasado',
  mock_skip_introduction: '¿Saltar instrucciones?',
  Listening: 'Comprensión auditiva',
  Reading: 'Lectura',
  Writing: 'Escritura',
  personal_info_display_name_as: 'Nombre para mostrar en el certificado',
  code_pratice_text: 'Usar <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> para el simulacro <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span>',
  code_input_text: 'Introduzca un código de canje:',
  use_code_limit: 'Cada código de canje es de un solo uso',
  code_select_text: 'O seleccione un código de canje:',
  pay_discounts_desc1: 'A través de la práctica con exámenes reales de años anteriores, puede ayudarte a',
  pay_discounts_desc2: 'obtener los mejores resultados en su examen [{type}] [{level}]',
  pay_discounts_desc3: 'Compre uno y llévese otro gratis',
  pay_discounts_desc4: 'Si ya se ha registrado para un examen [{type} {level}] oficial, puede disfrutar de la oferta "compre uno y llévese otro gratis" al comprar simulacros [{type} {level}]',
  pay_discounts_desc5: '¿Cuántos simulacros de examen desea comprar?',
  level_HSKK_text1: 'El examen oral HSK evalúa la competencia oral en chino del candidato. Incluye tres niveles: inicial, intermedio y avanzado.',
  level_HSKK_text2: 'El examen oral HSK se realiza en formato de grabación.',
  level_HSKK_text3: 'Los candidatos de HSK nivel 3 deben aprobar el examen HSKK nivel inicial, los candidatos de HSK nivel 4 deben aprobar el examen HSKK nivel intermedio, y los candidatos de HSK niveles 5 y 6 deben aprobar el examen HSKK nivel avanzado',
  test_download_desc: 'Los simulacros de examen para este nivel están en preparación. Mientras tanto, descargue:',
  speaking: 'Oral',
  Traduction: 'Traducción',
  my_homework_none_homework: 'Este nivel aún no admite la asignación de simulacros de examen, espere con anticipación.',
  my_class_none_test: 'Este nivel aún no admite la realización de simulacros de examen en línea, espere con anticipación.',
  hsk_audio_error: 'Su entorno de red actual es inestable, la carga de audio ha fallado, por favor inténtelo de nuevo.',
  mock_join_campus_text1: '¿Acepta la invitación para unirse a esta comunidad de enseñanza, aprendizaje y evaluación de chino?',
  mock_join_campus_text2: 'Después de unirse a la comunidad, los docentes pueden asignarle exámenes en HSKMock.com o ejercicios en app.wohuimandarin.com.',
  sso_join_campus_text4: 'Los docentes pueden ver sus respuestas para proporcionar retroalimentación específica.',
  join: 'Unirse',

  // Free Practice
  free_practice_title: 'Práctica gratuita',
  choose_free_practice: 'Seleccione un método de práctica',
  word_flashcards: 'Flashcards de vocabulario',
  word_practice: 'Práctica de vocabulario',
  analyse_text: 'Analizar texto',
  flashcards_title: 'Flashcards',
  practice_exercises_title: 'Ejercicios de práctica',
  analyse_title: 'Análisis',
  practice_result_title: 'Resultados de la práctica',
  generate_flashcards: 'Generar un conjunto de flashcards',
  generate_practice: 'Generar un conjunto de ejercicios',
  random_select: 'Selección aleatoria',
  manual_select: 'Selección manual',
  max_words: 'Máximo {number} palabras',
  already_choose: 'Seleccionado: {total}',
  free_practice_words_quantifier: '',
  free_practice_unchoose_question: 'Seleccione un tipo de pregunta',
  free_practice_unchoose_practice: 'Seleccione un tipo de práctica',
  none_mark_words_hint: 'Aún no ha marcado ninguna palabra en este nivel',
  excceed_max_count: 'Máximo {total} palabras seleccionables, ha alcanzado el límite',
  free_practice_sound: 'Sonido',
  free_practice_question: 'Pregunta',
  free_practice_choose_exercise: 'Seleccionar tipo de ejercicio',
  free_practice_exercise_select: 'Opción única',
  free_practice_exercise_Pairs: 'Emparejar',
  free_practice_exercise_TF: 'Verdadero/Falso',
  launch: 'Comenzar',
  free_practice_check_text: '¿Lo hizo correctamente?',
  free_practice_timer_pause: 'Pausar cronómetro',
  free_practice_timer_pause_desc: 'Si no se detecta actividad, el cronómetro se pausará automáticamente',
  free_practice_seconds: '{number} segundos',
  resume: 'Reiniciar',
  flashcard_completed: 'Flashcards completadas',
  practice_completed: 'Práctica completada',
  practice_spent_minutes: 'Tiempo total: {duration} minutos',
  practice_result_summary: 'Resumen de resultados',
  practice_result_progress_txt: 'Has obtenido',
  practice_wrong: 'Incorrecto',
  practice_skip: 'Omitido',
  practice_done: 'Completado',
  analyse_desc_1: 'Analizar texto según el vocabulario seleccionado',
  analyse_desc_2: 'Pegue o escriba texto en chino (máximo {maxCount} caracteres)',
  analyse_input_placeholder: 'Introduzca texto en chino',
  free_practice_need_word: 'Seleccione vocabulario de la tabla, o seleccione generación aleatoria de vocabulario',
  free_practice_exercise_select_title: 'Seleccione la respuesta correcta',
  free_practice_exercise_pairs_title: 'Haga clic para conectar y emparejar',
  free_practice_exercise_meaning_title: 'Debería traducirse como',
  free_practice_exercise_sound_title: 'Debería leerse como',
  free_practice_exercise_characters_title: 'Debería escribirse como',
  free_practice_show_correct_answers: 'Mostrar respuestas correctas',
  free_practice_show_my_answers: 'Mostrar mis respuestas',
  free_practice_check: 'Verificar',
  free_practice_correct: 'Correcto',
  free_practice_characters: 'Caracteres chinos',
  hsk_introduce_objective_questions: 'Preguntas objetivas',
  hsk_introduce_subjective_questions: 'Preguntas subjetivas',
  hsk_input_type_here: 'Introduzca aquí',
  hsk_translation_part_title: 'Traducción: Parte {count}',
  hsk_speaking_part_title: 'Oral: Parte {count}',
  subjective_reading_placeholder: 'Por favor responda la pregunta basándose en el artículo anterior…',
  hsk_write_by_artical: 'Por favor introduzca…',
  hsk_translation_by_artical: 'Por favor traduzca basándose en el material anterior…',
  hsk_trasnlation_choose_language: 'A continuación la sección de traducción, seleccione el idioma',
  choose_speaker: 'Seleccionar altavoz',
  choose_microphone: 'Seleccionar micrófono',
  hsk_is_recording: 'Grabando',
  dialogue_speaking: 'La última parte es la sección oral. Asegúrese de que los altavoces y el micrófono de su dispositivo funcionen correctamente.',
  start_recording: 'Haga clic para comenzar a grabar',
  hsk_write_count: 'Número de caracteres',
  error_access_media: 'Error al acceder a los dispositivos multimedia.',
  setSinkId_not_supported: 'Su navegador no admite {setSinkId}.',
  error_switch_device: 'Error al cambiar de dispositivo.',
  translation_section: 'Sección de traducción',
  speaking_section: 'Sección oral',
  failed_upload_record: 'Error al subir el audio grabado, haga clic para subir de nuevo.',
  hsk_enter_next_segment_write_high: '¿Enviar escritura? Después de enviar, la sección de escritura terminará y no podrá volver a modificarla.',
  hsk_enter_next_segment_translate_tip: 'Tiene {count} preguntas de traducción sin responder,',
  hsk_enter_next_segment_translate: '¿Enviar traducción? Después de enviar, la sección de traducción terminará y no podrá volver a modificarla.',
  hsk_enter_next_segment_speaking_tip: 'Tiene {count} preguntas orales sin responder,',
  Translating: 'Traducción',
  Speaking: 'Oral',

  // About Us
  back_to_home: 'Volver a la página principal',
  about_us_desc: '<b>HSK Mock</b> es una plataforma oficial en línea de simulación para los exámenes <b>HSK</b>, <b>HSK oral</b> y <b>YCT</b>. Reproduce fielmente el entorno real del examen, ayudando a los candidatos a prepararse con confianza, evaluarse con precisión y mejorar de forma integral.',
  who_we_are: 'Quiénes somos',
  who_we_are_desc: 'HSK Mock ha sido desarrollado conjuntamente por <b>Chinese Testing International</b> y <b>Wo Hui Mandarin</b>, con el objetivo de ofrecer a los estudiantes de chino de todo el mundo simulacros oficiales y herramientas de aprendizaje fiables y autorizados.',
  why_choose_hsk_mock: '¿Por qué elegir HSK Mock?',
  about_us_carousel_1: 'Banco oficial de simulacros',
  about_us_carousel_1_content: 'HSK Mock sigue estrictamente y reproduce fielmente la estructura de los exámenes oficiales HSK, HSK oral y YCT.',
  about_us_carousel_2: 'Sistema de calificación oficial',
  about_us_carousel_2_content: 'HSK Mock utiliza los mismos criterios de calificación que el examen oficial para evaluar con precisión el nivel real de los candidatos.',
  about_us_carousel_3: 'Herramientas de aprendizaje eficientes',
  about_us_carousel_3_content: 'HSK Mock también ofrece ejercicios de vocabulario específicos por nivel y funciones interactivas para mejorar integralmente las habilidades de comprensión auditiva, expresión oral, lectura y escritura en chino.',
  about_us_carousel_4: 'Uso flexible en múltiples dispositivos',
  about_us_carousel_4_content: 'HSK Mock es compatible con ordenadores y dispositivos móviles, permitiendo practicar en cualquier momento y lugar.',
  about_us_carousel_5: 'La elección de estudiantes de todo el mundo',
  about_us_carousel_5_content: 'HSK Mock ha ayudado a estudiantes de todo el mundo a alcanzar sus objetivos de aprendizaje del idioma.',

  // For Teachers
  for_teachers_banner_title: 'Plataforma oficial de simulación de examen, para escuelas y equipos globales',
  for_teachers_banner_desc: 'La plataforma oficial de simulación HSK integra exámenes oficiales reales, calificación profesional, refuerzo de vocabulario y práctica adaptativa. A través de HSK Mock, puede evaluar el nivel de chino en línea en cualquier momento y lugar, experimentando el examen real HSK y YCT. Es la elección de confianza para escuelas internacionales, universidades, equipos de recursos humanos empresariales y gestores de movilidad global.',
  for_teachers_banner_btn: 'Reservar demo',
  for_schools: 'Para escuelas y educadores',
  for_schools_desc: 'Ayude a los estudiantes a prepararse con confianza para el examen a través de simulacros oficiales HSK y YCT.',
  for_schools_list_1: 'Proceso de examen consistente con el examen oficial, simulando el entorno real de examen',
  for_schools_list_2: 'Compatible con múltiples dispositivos, pruebas en línea en cualquier momento y lugar',
  for_schools_list_3: 'Calificación instantánea para HSK niveles 1-3, YCT niveles 1-4',
  for_schools_list_4: 'Seguimiento del progreso individual y de clase en cualquier momento',
  for_corporates: 'Para empresas y equipos de recursos humanos',
  for_corporates_desc: 'Evaluación de chino flexible y rápida, satisfaciendo las necesidades de reubicación, asignación, contratación y negocios de empleados.',
  for_corporates_list_1: 'Filtrado de idiomas antes de la reubicación y evaluación de referencia interna',
  for_corporates_list_2: 'Resultados instantáneos para HSK niveles 1-3; resultados de examen HSK niveles 4-6 disponibles en 48 horas',
  for_corporates_list_3: 'Seguimiento del progreso después de la formación',
  for_corporates_list_4: 'Evaluación en línea o fuera de línea, en cualquier momento y lugar',
  official_format: 'Proceso oficial',
  official_format_desc: 'Simula los exámenes reales HSK y YCT, reproduciendo la experiencia real de examen.',
  smart_scoring: 'Calificación profesional',
  smart_scoring_desc: 'Calificación basada en estándares oficiales.',
  progress_analytics: 'Análisis de progreso',
  progress_analytics_desc: 'Análisis y seguimiento detallados según el desempeño del estudiante o equipo.',
  remote_access: 'Acceso remoto',
  remote_access_desc: 'Completamente basado en web, disponible en cualquier momento y lugar.',
  why_use_hsk: 'Para quién es la plataforma oficial de simulación HSK Mock',
  international_schools: 'Escuelas internacionales',
  international_schools_desc: 'Ofrece cursos de chino conformes a los estándares HSK/YCT, con capacidad de evaluación escalable.',
  universities_institutes: 'Universidades e institutos de formación profesional',
  universities_institutes_desc: 'Proporciona soporte oficial de pruebas para cursos de chino académico.',
  global_corporates: 'Empresas globales',
  global_corporates_desc: 'Evalúa y comprende el nivel de chino de los empleados para puestos orientados al mercado chino.',
  language_training_providers: 'Instituciones educativas',
  language_training_providers_desc: 'Proporciona simulacros conformes a los estándares oficiales para los estudiantes.',
  ready_to_access: '¿Listo para evaluar el nivel de chino?',
  book_live_demo: 'Reserve una demostración presencial, active una cuenta de prueba, vea el análisis de resultados y comience a usar HSK Mock rápidamente.',
  book_demo: 'Reservar demo',
  institutional_title: 'Evaluación de competencia en chino para instituciones educativas',
  institutional_desc: 'La plataforma oficial de simulación HSK Mock ofrece evaluación en línea de competencia en chino consistente con el formato oficial de exámenes HSK y YCT, ayudando a escuelas, universidades y diversas instituciones educativas a evaluar el nivel de chino de los estudiantes y realizar seguimiento continuo del progreso de aprendizaje.',
  institutional_btn: 'Ver soluciones para escuelas/instituciones',
  institutional_schools_title: 'Escuelas e instituciones educativas',
  institutional_schools_desc: 'Ayuda a los estudiantes a prepararse sistemáticamente para los exámenes HSK y YCT a través de exámenes reales de años anteriores.',
  institutional_corp_title: 'Empresas y equipos de recursos humanos',
  institutional_corp_desc: 'Utilizado para la evaluación de competencia en chino en contratación, reubicación o programas de formación, ayudando a las empresas a comprender y gestionar de manera más eficiente la capacidad lingüística de los empleados.',
  real_hsk_exam_content_new: 'Elige tu nivel de HSK',
  real_hsk_exam_desc_new: 'Completa una breve prueba de nivel para obtener el nivel HSK recomendado.',
  official_level_scoring_new: 'Participa en el simulacro oficial HSK',
  vocabulary_boost_new: 'Refuerza tu vocabulario',
  vocabulary_boost_desc_new: 'Ofrecemos flashcards de vocabulario gratuitas y herramientas de práctica inteligente.',
  confidence_card0_detail_desc: 'Completa una breve prueba de nivel para obtener el nivel HSK recomendado.',
  confidence_card0_detail_btn: 'Prueba de nivel gratuita',
  confidence_choose_level: 'Seleccionar nivel',
  confidence_card1_detail_btn: 'Continuar',
  confidence_choose_method: 'Selecciona un método de práctica',

  // Additional keys
  hsk_start_exam_new: 'Empezar',
  hsk_reference_answer_hskk: 'Contenido de audio del examen:',
  hsk_answer_sheet: 'Hoja de respuestas',
  level_PRIMARY: 'Nivel inicial',
  hsk_levels_tri: 'Nuevo HSK',
  hsk_speaking_tri: 'Nuevo HSK oral',
  start_learning: '¡Empieza a aprender ahora!',
  for_institutions: 'Escuelas y organizaciones educativas',
  for_hsk3_condidates: 'Dirigido a candidatos del HSK3',
  for_hsk4_condidates: 'Dirigido a candidatos del HSK4',
  for_hsk56_condidates: 'Dirigido a candidatos del HSK5-6',
  tofficial_platform_new: 'Plataforma oficial de simulación del examen HSK',
  proficiency_tests_new: 'Integra exámenes oficiales reales, sistema de calificación oficial, refuerzo de vocabulario y práctica adaptativa para optimizar la preparación del examen',
  get_started_new: 'Empezar',
  start_practicing: 'Empezar a practicar',
  real_hsk_exam_content: 'Exámenes oficiales reales',
  real_hsk_exam_desc: 'Practica con exámenes oficiales reales para prepararte de forma eficiente y afrontar el examen con confianza.',
  official_level_scoring: 'Calificación profesional',
  official_level_scoring_desc: 'Calificación basada en los estándares oficiales del HSK, con resultados precisos y fiables.',
  vocabulary_boost: 'Refuerzo de vocabulario',
  vocabulary_boost_desc: 'Utiliza flashcards de vocabulario gratuitas y herramientas de práctica adaptativa para memorizar eficazmente cada palabra.',
  get_hsk_ready: 'Guía completa de preparación HSK',
  how_it_works: 'Cómo usar',
  choose_your_level: 'Seleccionar nivel',
  choose_your_level_desc: 'Selecciona el nivel de examen adecuado — desde HSK nivel 1 hasta HSK nivel 9.',
  practise_and_learn: 'Formación y evaluación',
  practise_and_learn_desc: 'Empieza con el entrenamiento gratuito de vocabulario. Actualiza tu cuenta para desbloquear los simulacros oficiales completos del HSK y el servicio de calificación inteligente.',
  track_your_progress: 'Seguimiento del progreso de aprendizaje',
  track_your_progress_desc: 'Consulta las puntuaciones por sección tras cada prueba, realiza un seguimiento continuo de tu progreso, identifica áreas de mejora y optimiza tu planificación de estudio.',
  got_questions: '¿Tienes preguntas? Tenemos las respuestas',
  faq: 'Preguntas frecuentes',
  faq_desc: 'Preguntas frecuentes sobre la preparación del HSK y el uso de la plataforma HSK Mock.',
  faq_btn: 'Ver preguntas frecuentes',
  blog: 'Blog',
  blog_desc: 'Explora nuestro blog para descubrir consejos prácticos sobre la preparación del HSK.',
  blog_btn: 'Explorar el blog',
  contact: 'Contáctanos',
  contact_desc: '¿Necesitas asistencia personalizada? Nuestro equipo de atención al cliente está disponible para ayudarte.',
  contact_btn: 'Contáctanos',
  mock_tests: 'Examen de simulación',
  blog_and_faq: 'Blog y preguntas frecuentes',
  real_results_from_real_learners: 'Resultados reales, evaluación auténtica',
  support: 'Ayuda y soporte',
  choose_your_hsk_level: 'Elige tu nivel de HSK',
  choose_your_hsk_level_desc: 'Prepárate para el HSK, HSK oral y YCT con simulacros oficiales y herramientas inteligentes.',
  hsk_levels: 'HSK',
  hsk_speaking: 'HSK oral',
  yct: 'YCT',
  more_menu: 'Más información',
  get_ready: '¡Empieza ahora tu preparación del HSK!',
  footer: 'HSK Mock es la plataforma oficial de simulación del examen HSK que integra exámenes oficiales reales, calificación profesional, refuerzo de vocabulario y práctica adaptativa para optimizar la preparación del examen.',
  on_the_move_new: 'Descarga la app HSK Mock,',
  download_mobile_new: 'prepárate para el HSK en cualquier momento y lugar.',
}
